<template>
  <perfect-scrollbar class="modal-window flex items-center">
    <div class="event-modal-wrapper">
      <div class="border-radius shadow bg-white bg-darkmode">
        <div class="flex font-h6">
          <div class="flex-1 pl-30 py-20 p-20-xs">
            <div class="flex items-center">
              <h4 class="mb-0 strong flex-1">{{ $t("nav.share_your_link") }}</h4>
              <button class="button-square ml-10 visible-xs" @click="$emit('close')">
                <i class="la la-times big-text"></i>
              </button>
            </div>

            <ul class="pills mt-30 pills-block-xs mt-15-xs">
              <li :class="{ active: tab == 'link' }" @click="tab = 'link'" class="px-5-xs">
                <i class="la la-link big-text mr-5"></i> {{ $t("nav.share_a_link") }}
              </li>
              <li :class="{ active: tab == 'website' }" @click="tab = 'website'" class="px-5-xs">
                <i class="la la-globe big-text mr-5"></i> {{ $t("nav.add_to_website") }}
              </li>
            </ul>
          </div>
          <div
            class="flex-1 pr-30 py-20 align-right ml-30 hide-xs bg-darkmode-important"
            style="border-top-right-radius: 5px"
            :style="{
              'background-color': tab == 'link' ? '#fff' : '#f5f6fa',
            }">
            <button class="button-square" @click="$emit('close')">
              <i class="la la-times big-text"></i>
            </button>
          </div>
        </div>

        <!-- Share a link -->
        <div v-if="tab == 'link'" class="px-30 pb-30 pt-10 px-20-xs">
          <h6 class="mb-15">{{ $t("text.copy_past_calendo_link_message") }}</h6>
          <div class="flex items-center">
            <i class="la la-link big-text mr-10 hide-xs"></i>
            <div
              class="border-radius flex-1 div-border px-10 py-5 bg-lightblur bg-lightblur-darkmode-important flex items-center block-xs no-bg-xs no-border-xs p-0-xs"
              style="background-color: #f5f6fa">
              <h4 class="mb-0 flex-1 font-h5-xs hide-xs">{{ myLink }}</h4>
              <h4 class="mb-0 flex-1 font-h5-xs visible-xs div-border px-10 py-5 border-radius" style="background-color: #f5f6fa">
                {{ myLink }}
              </h4>
              <button class="btn btn-large btn-primary mt-10-xs" v-ripple @click="copyLink">
                {{ $t("button.copy_link") }}
              </button>
            </div>
          </div>
          <br />
        </div>

        <!-- Add to website -->
        <div v-else>
          <div style="border-radius: 0 0 5px 5px" class="flex block-xs">
            <div class="flex-1 px-30 px-10-xs">
              <div class="pb-15 pt-10 px-10-xs">
                <h6>{{ $t("text.how_to_add_weezly_website") }}</h6>
              </div>
              <div class="share-options" style="display: block">
                <div class="share-option mb-30" style="max-width: 100%" :class="{ active: widget_type == 'inline' }" @click="widget_type = 'inline'">
                  <img src="@/assets/img/icons/share-inline.png" alt="" />
                  <div class="flex-1 pl-15">
                    <h6 class="strong">{{ $t("text.inline_embed") }}</h6>
                    <i18n tag="h6" class="mb-0 font-body-xs" path="text.add_weezly_page_to_your_website"
                      ><template slot="br"><br /></template
                    ></i18n>
                  </div>
                </div>

                <div class="share-option mb-30" style="max-width: 100%" :class="{ active: widget_type == 'popup' }" @click="widget_type = 'popup'">
                  <img src="@/assets/img/icons/share-widget.png" alt="" />
                  <div class="flex-1 pl-15">
                    <h6 class="strong">{{ $t("text.popup_widget") }}</h6>
                    <i18n tag="h6" class="mb-0 font-body-xs" path="text.add_floating_button"
                      ><template slot="br"><br /></template
                    ></i18n>
                  </div>
                </div>

                <div class="share-option mb-30" style="max-width: 100%" :class="{ active: widget_type == 'text' }" @click="widget_type = 'text'">
                  <img src="@/assets/img/icons/share-text.png" alt="" />
                  <div class="flex-1 pl-15">
                    <h6 class="strong">{{ $t("text.popup_text") }}</h6>
                    <i18n tag="h6" class="mb-0 font-body-xs" path="text.add_a_text_link_open_popup"
                      ><template slot="br"><br /></template
                    ></i18n>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1 p-15 bg-darkmode-important" style="background-color: #f5f6fa; border-bottom-right-radius: 5px">
              <ShareInline v-if="widget_type == 'inline'" />
              <SharePopup v-else-if="widget_type == 'popup'" />
              <ShareText v-else-if="widget_type == 'text'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </perfect-scrollbar>
</template>

<script>
import { copyClipboard } from "@/helpers/functions.js";
import ShareInline from "./ShareInline.vue";
import SharePopup from "./SharePopup.vue";
import ShareText from "./ShareText.vue";
export default {
  name: "Share",
  components: {
    ShareInline,
    SharePopup,
    ShareText,
  },
  props: {},
  data: function () {
    return {
      tab: "link",
      widget_type: "inline",
    };
  },
  computed: {
    settings() {
      return this.$store.getters.getSchedulingSettings;
    },
    myLink() {
      return this.external_link + "/" + this.settings.link;
    },
  },
  async mounted() {},
  methods: {
    copyLink() {
      copyClipboard(this.myLink);
      this.$root.$emit("alert", this.$t("alert.copied_link"));
    },
  },
};
</script>
